module.exports = __webpack_public_path__ + "media/02_final.6bc21cbd.mp4";